import { render, staticRenderFns } from "./PermissionsGroups.vue?vue&type=template&id=9fb1fdec&scoped=true&"
import script from "./PermissionsGroups.vue?vue&type=script&lang=js&"
export * from "./PermissionsGroups.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsGroups.vue?vue&type=style&index=0&id=9fb1fdec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb1fdec",
  null
  
)

export default component.exports